<template>
  <footer id="footer-unsubscribe">
    <div class="footer_container">
      <div>
        <div class="details__address">{{ cancellation.company1 }}</div>
        <div class="details__address">{{ cancellation.company4 }}</div>
        <div class="details__address">{{ cancellation.company5 }}</div>
      </div>
      <div>
        <div class="details__address">
          {{ cancellation.phone }} {{ specific.phone }}
        </div>
        <div class="details__address">{{ cancellation.workTime }}</div>
        <div class="details__address">
          {{ cancellation.email }} {{ specific.email }}
        </div>
      </div>
    </div>
    <div class="copy">
      © {{ year }} All rights reserved
    </div>
  </footer>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "Footer",
      data() {
        return {
          year: null
        }
      },
      mounted() {
          const date = new Date()
          this.year = date.getFullYear()
      },
      computed:{
            ...mapState([
                'vocab', 'locale', 'specific'
            ]),
            cancellation() {
                return this.vocab[this.locale].cancellation;
            },
        }
    }
</script>

<style lang="scss">
  .footer_container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;

    max-width: 1140px;
    margin: 0 auto;
    padding-left: 10px;
    padding-right: 10px;

    @media (max-width: 991px) {
      grid-template-columns: 1fr;
      max-width: 465px;
    }

    .details__address {
      justify-content: flex-start !important;
    }
  }

  .copy {
    background-color: #fff;
    margin-top: 50px;
    color: #000;
    text-align: center;
  }
</style>